module.exports = __webpack_public_path__ + "static/media/critical.a0a104a7.svg";